export default __webpack_public_path__ + "static/media/cover.9542c461.jpg";